import { useState } from 'react';
import { sendEmailApi } from '../api/email_api';
import '../styles/SendEmail.css';
import '../styles/Common.css';

const SendEmail = ({ recipientEmail, onClose }) => {
  const [subject, setSubject] = useState('');
  const [emailBody, setEmailBody] = useState('');

  const handleSend = async () => {
    try {
      await sendEmailApi({
        to: recipientEmail,
        subject,
        text: emailBody,
      });
      alert('המייל נשלח בהצלחה!');
      onClose();
    } catch (err) {
      console.error(err);
      alert('שגיאה בשליחת המייל');
    }
  };

  // כפתור מושבת אם אין נושא או תוכן
  const isSendDisabled = subject.trim() === '' || emailBody.trim() === '';

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <div className="popup-header">
          <h2>שליחת מייל ל: {recipientEmail}</h2>
          <button className="close-email" onClick={onClose}>×</button>
        </div>

        <input
          type="text"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          placeholder="נושא המייל"
          className="subject-email"
        />

        <textarea
          value={emailBody}
          onChange={(e) => setEmailBody(e.target.value)}
          placeholder="כתוב כאן את תוכן המייל"
          className="email-body"
        />

        <button
          className="send-email"
          onClick={handleSend}
          disabled={isSendDisabled} // כאן הכפתור מושבת אם השדות ריקים
        >
          שלח
        </button>
      </div>
    </div>
  );
};

export default SendEmail;
